export const state = () => ({
	current_step: 1,
	achievement: null,
	all_achievements: [],
});

export const mutations = {
	setCurrentStep(state: any, payload: any) {
		state.current_step = payload;
	},
	setAchievement(state: any, payload: any) {
		state.achievement = payload;
	},
	setAllAchievements(state: any, payload: any) {
		state.all_achievements = payload;
	},
};

export const getters = {
	getCurrentStep: (state: any) => state.current_step,
	getAchievement: (state: any) => state.achievement,
	getAllAchievements: (state: any) => state.all_achievements,
};

export const actions = {
	async getAllAchievements(state: any, payload: any) {
		if (!(state.state.all_achievements.length > 0)) {
			return new Promise((resolve, reject) => {
				this.$axios
					.get('/api/profile/achievements')
					.then((res) => {
						state.commit('setAllAchievements', res.data);
						resolve(res);
					})
					.catch((err) => {
						reject(err);
					});
			});
		} else {
			return new Promise((resolve, reject) => {
				resolve(state.state.all_achievements);
			});
		}
	},

	async getAchievement(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/profile/achievements/' + payload)
				.then((res) => {
					state.commit('setAchievement', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async createAchievement(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/profile/achievements', payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async editAchievement(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.put('/api/profile/achievements/' + payload.uuid, payload.data)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async deleteAchievement(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.delete('/api/profile/achievements/' + payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async createDocument(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post(
					'/api/profile/achievements/' + payload.uuid + '/documents',
					payload.data,
				)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	updateAllAchievements(state: any, payload: any) {
		state.commit('setAllAchievements', payload);
	},

	updateAchievement(state: any, payload: any) {
		state.commit('setAchievement', payload);
	},

	updateCurrentStep(state: any, payload: any) {
		state.commit('setCurrentStep', payload);
	},
};
